import React, { useEffect, useState } from "react";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import axios from "axios";
import userAction from "../redux/users/action";
import { OtpModal } from "./otpModal";
import showPassImg from "../images/showPass.svg";
import hidePass from "../images/hidePass.svg";
import "./auth.css";

export const ForgetPass = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const userStore = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const [data, setData] = useState({
    email: "",
  });
  const [loader, setLoader] = useState(false);

  const validators = () => {
    if (!data.email) {
      return "Email is required";
    }
    return false;
  };

  const onTextChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const submitForgetPass = async (e) => {
    try {
      e.preventDefault();
      let check = validators();
      if (check) {
        alert.show(check);
        return;
      }
      setLoader(true);
      // /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      var expression = new RegExp(
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]+)*$/,
      );
      if (expression.test(data.email)) {
        // console.log(data.email);
        const res = await api.forgetPass({ email: data.email });
        // console.log(res);
        if (res?.success) {
          setLoader(false);
          alert.show("Please check your email to reset password.");
          setData({ email: "" });
        } else {
          alert.show("Invalid email address");
          setLoader(false);
        }
      } else {
        alert.show("Invalid email address");
        setLoader(false);
      }
    } catch (error) {
      // console.log(error);
      // console.log(error?.code);
      console.log(error?.message);
      alert.show("Something went wrong.");
      setLoader(false);
    }
  };

  return (
    <>
      <div className="wzAuthStage">
        <div className="wzAuth-orb o1"></div>
        <div className="wzAuth-orb o2"></div>

        <div className="wzAuth-frame">
          <form noValidate id="contactForm" className="wzAuth-card">
            <div className="wzAuth-head">
              <div className="wzAuth-badge">
                <i className="fa-solid fa-key" />
              </div>
              <h1>Forgot Password?</h1>
              <p>Enter your email and we'll send you a reset link.</p>
            </div>

            <div className="wzAuth-form">
              <div>
                <label className="wzAuth-label c-email" htmlFor="email">
                  Email
                </label>
                <div className="wzAuth-field">
                  <span className="ic">
                    <i className="fa-solid fa-envelope" />
                  </span>
                  <input
                    onChange={onTextChange}
                    type="text"
                    name="email"
                    value={data?.email}
                    id="email"
                    required
                    placeholder="you@example.com"
                    className="wzAuth-input"
                  />
                </div>
              </div>

              <button
                onClick={submitForgetPass}
                type="submit"
                className="wzAuth-submit"
                disabled={loader}
              >
                <span className="wzAuth-shine"></span>
                <span className="label">
                  {loader ? (
                    <>
                      <i
                        className="fa fa-spinner fa-pulse me-2"
                        style={{ position: "relative", top: "-0px" }}
                      ></i>
                      Sending...
                    </>
                  ) : (
                    "Send Reset Link"
                  )}
                </span>
              </button>

              <p className="wzAuth-foot">
                Remember your password? <Link to={"/login"}>Log in</Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
